import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { NewPatients } from './pages/NewPatients';
import { FinancingPage } from './pages/FinancingPage';
export function App() {
  return <div className="w-full h-full" data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/new-patients" element={<NewPatients data-id="element-6" />} data-id="element-5" />
          <Route path="/financing" element={<FinancingPage data-id="element-8" />} data-id="element-7" />
        </Routes>
      </BrowserRouter>
    </div>;
}